import 'core-js';
import 'regenerator-runtime/runtime';
var urlParams = new URLSearchParams(window.location.search);
var version = urlParams.get('version') || '3.0.0';
if (typeof version === 'string' && version !== '3.0.0' && version !== '2.3.0') {
    throw new Error("incorrect version: ".concat(version));
}
window.__LINK_VERSION__ = version;
require('../index');
